import { IResume } from 'shared/interfaces/ITalent';
import { v4 as uuidv4 } from 'uuid';

export const RESUME_DEFAULT_DATA: IResume['attributes']['resume'] = {
  categories: [
    {
      category: 'Film',
      category_id: uuidv4(),
      credits: [],
    },
    {
      category: 'Television',
      category_id: uuidv4(),
      credits: [],
    },
    {
      category: 'Theatre',
      category_id: uuidv4(),
      credits: [],
    },
    {
      category: 'Print / Fashion',
      category_id: uuidv4(),
      credits: [],
    },
    {
      category: 'Commercial',
      category_id: uuidv4(),
      credits: [],
    },
  ],
  hide_years: false,
};
